import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { useQuery } from "@tanstack/react-query";
import type { Shape, Component, UnifiedResponse } from "@/types/diagram";
import { segregateShapesAndComponents } from "@/lib/utils";
import { apiFetch } from "@/lib/api-client";

export const getShapesByName = async (
  names: string[],
  token?: string
): Promise<
  | {
      shapes: Shape[];
      components: Component[];
      total: number;
    }
  | undefined
> => {
  const params = names
    .map((item) => "filters[name][$in]=" + encodeURIComponent(item))
    .join("&");
  const url = `${config.isometricApiUrl}/shapes?${params}&Page=1&limit=1000`;

  const headers: HeadersInit = token 
    ? { 'Authorization': `Bearer ${token}` }
    : {};

  try {
    const response = await apiFetch(url, {
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const shapesResp: { data: UnifiedResponse[]; total: number } =
      await response.json();
    const segregatedData = segregateShapesAndComponents(shapesResp?.data ?? []);
    return { ...segregatedData, total: shapesResp.total };
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
export default function useGetShapesByNameService(
  names: string[],
  enabled?: boolean,
  token?: string
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useQuery({
    queryKey: ["shapes-by-name", names, token],
    queryFn: () => getShapesByName(names, token || getAuthHeaders()?.Authorization?.replace('Bearer ', '')),
    enabled: !!enabled && names.length > 0,
  });
}
